const NAMED_HTML_ENTITIES: Record<string, string> = {
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  nbsp: '\u00A0',
  quot: '"',
}

export function decodeHtmlEntities(text: string): string {
  return text.replace(/&(#x[0-9a-fA-F]+|#\d+|[a-zA-Z]+);/g, (match, entity: string) => {
    if (entity.startsWith('#x')) {
      const codePoint = parseInt(entity.slice(2), 16)
      return Number.isNaN(codePoint) ? match : String.fromCodePoint(codePoint)
    }

    if (entity.startsWith('#')) {
      const codePoint = parseInt(entity.slice(1), 10)
      return Number.isNaN(codePoint) ? match : String.fromCodePoint(codePoint)
    }

    return NAMED_HTML_ENTITIES[entity] ?? match
  })
}

export const removeTrailingSlash = (str: string = '') => str.replace(/\/+$/, '')
export const removeQueryParams = (str: string = '') => str.replace(/(\?.*)|(#.*)/g, '')

export function safeParse<T>(input: string | undefined): T | null {
  try {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return JSON.parse(input || 'null') as T
  } catch (e) {
    return null
  }
}

export function safeQueryParamParse<T = any>(input?: string | null) {
  try {
    return safeParse(atob(decodeURIComponent(input ?? ''))) as T
  } catch (error) {
    return null
  }
}

/** Converts all email addresses in a string to mailto links */
export function createEmailLinks(text: string = '') {
  const emailPattern = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi
  return text.replace(emailPattern, (match) => `<a href="mailto:${match}">${match}</a>`)
}
